"use client";
import { useEffect, useState } from "react";
import { shouldAutoReload, bumpReloadCount } from "@/lib/errorReload";

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  const [isAutoRetrying, setIsAutoRetrying] = useState(true);

  useEffect(() => {
    console.error("app/error caught:", error);
  }, [error]);

  useEffect(() => {
    if (shouldAutoReload()) {
      bumpReloadCount();
      // silent reload - not noticeable, ~100ms to allow log flush
      const t = window.setTimeout(() => window.location.reload(), 100);
      return () => window.clearTimeout(t);
    } else {
      setIsAutoRetrying(false);
    }
  }, [error]);

  if (isAutoRetrying) {
    // invisible silent retry - looks like normal loading, no Try again flash
    return (
      <div className="flex min-h-[50vh] flex-col items-center justify-center p-8">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-slate-200 border-t-saintiantblue" />
      </div>
    );
  }

  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center p-8 text-center">
      <h2 className="text-2xl font-black text-saintiantblue">Application error</h2>
      <p className="mt-3 max-w-md text-sm text-slate-600">
        A client-side exception has occurred. Please refresh or try again.
      </p>
      {error?.message && <p className="mt-2 text-xs text-slate-400">{error.message}</p>}
      <button
        onClick={() => window.location.reload()}
        className="mt-6 rounded-full bg-saintiantblue px-6 py-3 text-sm font-semibold text-white"
      >
        Try again
      </button>
    </div>
  );
}
